<script>
    export let fill = '#000'
</script>

<style>
    svg {
        position: absolute;
        width: 412.23px;
        height: 25.79px;
        top: 207px;
        left: 0;
    }
</style>

<svg id="nextevent-label" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1175.94 67.57">
    <g>
        <rect {fill} id="topbar" y="0" width="1175.94" height="67.57"/>
    </g>
</svg>
